// extracted by mini-css-extract-plugin
module.exports = {"article":"Photos_article__33xsh","video":"Photos_video__2Rjz5"};